<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="currencyList"
      :items="currencyList"
      :fields="currencyFields"
      :filter="filter"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="currentRowCurrency" :isEdit="isEdit"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      isEdit: null,
      currentRowCurrency: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      currencyFields: [
        {key: 'currency_id', label: 'ID', sortable: true},
        {key: 'currency_brief_name', label: this.$i18n.t('Abbreviation'), sortable: true},
        {key: 'currency_full_name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'percent', label: this.$i18n.t('Percent'), sortable: true},
        {key: 'rate', label: this.$i18n.t('Rate'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    showAdd () {
      this.isEdit = false
      this.currentRowCurrency = {
        currency_id: '',
        currency_brief_name: '',
        currency_full_name: '',
        percent: '',
        rate: ''
      }
      this.$root.$emit('bv::show::modal', 'modalEditCurrency', '#btnShow')
    },
    editItem (item) {
      this.currentRowCurrency = JSON.parse(JSON.stringify(item))
      this.isEdit = true
      this.$root.$emit('bv::show::modal', 'modalEditCurrency', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Currency"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('ReferenceBooks/DELETE_CURRENCIES', item.currency_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'ReferenceBooks/GET_CURRENCIES')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    currencyList () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/CURRENCIES']))
      for (let el of copy) {
        el.ratesEditModal = []
        let time = []
        for (let elTime of el.rates) {
          let newEl = {
            time: '',
            rate: 0
          }
          newEl.rate = elTime.rate
          if (elTime.time === 0) {
            newEl.time = this.$i18n.t('Not installed')
          } else {
            newEl.time = this.$root.showDataWithTZDelta(elTime.time)
          }
          el.ratesEditModal.push(newEl)
          time.push(elTime.time)
        }
        let maxTime = Math.max.apply(null, time)
        for (let elTRate of el.rates) {
          if (elTRate.time === maxTime) {
            el.rate = elTRate.rate
          }
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('ReferenceBooks/GET_CURRENCIES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/currency/main.vue